// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationTemplateAttributeId } from './HarvestOperationTemplateAttribute';
import { harvestTabularColumnLineageId } from './HarvestTabularColumnLineage';
import { z } from 'zod';
export const harvestTemplateTabularColumnId = (z.number());
export const harvestTemplateTabularColumn = z.object({
    id: harvestTemplateTabularColumnId,
    template_attribute_id: harvestOperationTemplateAttributeId,
    name: z.string(),
    data_type: z.string(),
    is_index: z.boolean(),
    is_computed: z.boolean(),
    formula: z.string().nullable(),
    formula_result_unit: z.string().nullable(),
    formula_result_display_unit: z.string().nullable(),
    required: z.boolean(),
    unit: z.string().nullable(),
    sort_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    display_width: z.number().nullable(),
    code: z.string().nullable(),
    lineage_id: harvestTabularColumnLineageId,
    applicable_scale_ids: z.number().array().nullable(),
    text_options: z.string().array().nullable(),
});
export const harvestTemplateTabularColumnInitializer = z.object({
    id: harvestTemplateTabularColumnId.optional(),
    template_attribute_id: harvestOperationTemplateAttributeId,
    name: z.string(),
    data_type: z.string(),
    is_index: z.boolean().optional(),
    is_computed: z.boolean().optional(),
    formula: z.string().optional().nullable(),
    formula_result_unit: z.string().optional().nullable(),
    formula_result_display_unit: z.string().optional().nullable(),
    required: z.boolean().optional(),
    unit: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    display_width: z.number().optional().nullable(),
    code: z.string().optional().nullable(),
    lineage_id: harvestTabularColumnLineageId,
    applicable_scale_ids: z.number().array().optional().nullable(),
    text_options: z.string().array().optional().nullable(),
});
export const harvestTemplateTabularColumnMutator = z.object({
    id: harvestTemplateTabularColumnId.optional(),
    template_attribute_id: harvestOperationTemplateAttributeId.optional(),
    name: z.string().optional(),
    data_type: z.string().optional(),
    is_index: z.boolean().optional(),
    is_computed: z.boolean().optional(),
    formula: z.string().optional().nullable(),
    formula_result_unit: z.string().optional().nullable(),
    formula_result_display_unit: z.string().optional().nullable(),
    required: z.boolean().optional(),
    unit: z.string().optional().nullable(),
    sort_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    display_width: z.number().optional().nullable(),
    code: z.string().optional().nullable(),
    lineage_id: harvestTabularColumnLineageId.optional(),
    applicable_scale_ids: z.number().array().optional().nullable(),
    text_options: z.string().array().optional().nullable(),
});
//# sourceMappingURL=HarvestTemplateTabularColumn.js.map